// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper--Qn8he"};